module.exports = __webpack_public_path__ + "img/23.680564cd.png";